import { createContext, PropsWithChildren, useCallback, useContext, useEffect, useMemo, useState } from 'react';

const ViewportContext = createContext<{ width?: number; height?: number }>({});

export const ViewportProvider = ({ children }: PropsWithChildren) => {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  const handleWindowResize = useCallback(() => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);

    return () => window.removeEventListener('resize', handleWindowResize);
  }, [handleWindowResize]);

  const contextValue = useMemo(
    () => ({
      width,
      height,
    }),
    [width, height],
  );

  return <ViewportContext.Provider value={contextValue}>{children}</ViewportContext.Provider>;
};

export const useViewportContext = () => {
  return useContext(ViewportContext);
};
export const useIsMobile = () => {
  const { width } = useViewportContext();

  return !!width && width < 768;
};
